function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  fill: "#838D93",
  width: 40,
  height: 40,
  rx: 20
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9 15.435l11 8.001 11-8V28H9V15.435zM30.95 13L20 20.964 9.05 12.999h21.9z",
  fill: "#FFF"
});

var SvgSubscribe = function SvgSubscribe(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSubscribe, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDBweCIgaGVpZ2h0PSI0MHB4IiB2aWV3Qm94PSIwIDAgNDAgNDAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IGZpbGw9IiM4MzhEOTMiIHg9IjAiIHk9IjAiIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgcng9IjIwIj48L3JlY3Q+CiAgICA8cGF0aCBkPSJNOC45OTkwOTIyMiwxNS40MzUwOTIyIEwyMCwyMy40MzY0OTczIEwzMC45OTkwOTIyLDE1LjQzNjA5MjIgTDMxLDI4IEw5LDI4IEw4Ljk5OTA5MjIyLDE1LjQzNTA5MjIgWiBNMzAuOTUwMDkyMiwxMi45OTkwOTIyIEwyMCwyMC45NjM1MDI3IEw5LjA0OTA5MjIyLDEyLjk5OTA5MjIgTDMwLjk1MDA5MjIsMTIuOTk5MDkyMiBaIiBmaWxsPSIjRkZGRkZGIj48L3BhdGg+Cjwvc3ZnPg==";
export { ForwardRef as ReactComponent };